import { FC } from 'react';
import { RefreshCw } from 'lucide-react';
import { TabKey, DateRangeKey } from '../types';

interface DashboardHeaderProps {
    activeTab: TabKey;
    setActiveTab: (tab: TabKey) => void;
    dateRange: DateRangeKey;
    setDateRange: (range: DateRangeKey) => void;
    onRefresh: () => void;
    loading: boolean;
}

export const DashboardHeader: FC<DashboardHeaderProps> = ({
    activeTab,
    setActiveTab,
    dateRange,
    setDateRange,
    onRefresh,
    loading
}) => {
    return (
        <header className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100">
            <div className="px-6 lg:px-10 py-4 flex items-center justify-between">
                <div className="flex items-center gap-6">
                    <h1 className="text-lg font-bold text-slate-900">Dashboard</h1>
                    <nav className="flex gap-1 bg-slate-100 p-1 rounded-xl">
                        {(['sales', 'marketing', 'topics'] as TabKey[]).map((t) => (
                            <button
                                key={t}
                                onClick={() => setActiveTab(t)}
                                className={`px-4 py-2 text-xs font-semibold rounded-lg transition-all capitalize ${activeTab === t ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'
                                    }`}
                            >
                                {t}
                            </button>
                        ))}
                    </nav>
                </div>
                <div className="flex items-center gap-3">
                    <div className="flex gap-1 bg-slate-100 p-1 rounded-lg">
                        {(['7d', '30d', '90d'] as const).map((range) => (
                            <button
                                key={range}
                                onClick={() => setDateRange(range)}
                                className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${dateRange === range
                                    ? 'bg-white text-slate-900 shadow-sm'
                                    : 'text-slate-500 hover:text-slate-700'
                                    }`}
                            >
                                {range === '7d' ? '7 Days' : range === '30d' ? '30 Days' : '90 Days'}
                            </button>
                        ))}
                    </div>
                    <button
                        onClick={onRefresh}
                        disabled={loading}
                        className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                        <RefreshCw className={`w-3.5 h-3.5 ${loading ? 'animate-spin' : ''}`} />
                        Refresh
                    </button>
                </div>
            </div>
        </header>
    );
};
